import request from "@/api";
import type { ApiResponse } from "@/api/interface/apiResponse";
import { BaseService } from "@/api/services/baseService";
import type {
    Page,
    SpecialZoneWeighmentCreateData,
    SpecialZoneWeighmentCreateParams,
    SpecialZoneWeighmentUpdateParams,
    SpecialZoneWeighmentPagingPage,
    SpecialZoneWeighmentPagingParams,
    SpecialZoneWeighmentPagingRow,
    SpecialZoneWeighmentUpdateData
} from "@zhihaoscm/entity";

/** 专区过磅分页 — 完整 HTTP 响应体（与 `@/api/interface/apiResponse` 一致，拦截器成功后会取出其中 `data`） */
export type SpecialZoneWeighmentPagingApiResponse = ApiResponse<SpecialZoneWeighmentPagingPage>;

/** 专区过磅分页查询完整响应（与后端字段一致） */
export interface Paging_4Res extends ApiResponse<SpecialZoneWeighmentPagingPage> {
    success: boolean;
}

/** 专区过磅详情完整响应（与后端字段一致；拦截器成功后一般采用 {@link findSpecialZoneWeighmentVoById} 解构出的 data） */
export interface FindSpecialZoneWeighmentVoByIdRes extends ApiResponse<SpecialZoneWeighmentPagingRow> {
    success: boolean;
}

export class SpecialZoneWeighmentService extends BaseService<
    SpecialZoneWeighmentPagingRow,
    SpecialZoneWeighmentPagingRow,
    SpecialZoneWeighmentPagingParams,
    unknown
> {}

/**
 * 新增专区过磅单
 *
 * @param params.reservationOrderId 预约单编号
 * @param params.loadingEndTime 装船结束时间
 * @param params.shipId 船舶 ID
 * @param params.shipName 船舶名称
 * @param params.weighDetails 过磅物料明细项
 */
export async function createSpecialZoneWeighment(
    params: SpecialZoneWeighmentCreateParams
): Promise<SpecialZoneWeighmentCreateData> {
    const { data } = await request.service.post<SpecialZoneWeighmentCreateData>(`/admin/special-zone-weigh`, params);
    return data;
}

/**
 * 编辑专区过磅单
 *
 * @param id 过磅单 id
 * @param params 装船结束时间、船舶信息、附件与过磅明细；具备调价权限时明细可附带单价
 */
export async function updateSpecialZoneWeighment(
    id: string,
    params: SpecialZoneWeighmentUpdateParams
): Promise<SpecialZoneWeighmentUpdateData> {
    const { data } = await request.service.put<SpecialZoneWeighmentUpdateData>(
        `/admin/special-zone-weigh/${encodeURIComponent(id)}`,
        params
    );
    return data;
}

/**
 * 查询专区过磅详情（结构与列表行、新增返回一致）
 *
 * @param id 过磅单 id
 */
export async function findSpecialZoneWeighmentVoById(id: string): Promise<SpecialZoneWeighmentPagingRow> {
    const { data } = await request.service.get<SpecialZoneWeighmentPagingRow>(`/admin/special-zone-weigh/vo/${id}`);
    return data;
}

/** 专区过磅单分页列表 */
export async function paging_4(params: SpecialZoneWeighmentPagingParams): Promise<Page<SpecialZoneWeighmentPagingRow>> {
    const { data } = await request.service.get<Page<SpecialZoneWeighmentPagingRow>>(
        `/admin/special-zone-weigh/paging`,
        { params }
    );
    return data;
}

export const specialZoneWeighmentService = new SpecialZoneWeighmentService(
    "/admin/special-zone-weigh",
    request.service
);
